import React, { useState } from "react";
import { useSelector } from "react-redux";
import Navbar from "../components/Navbar/Navbar";
import Sidebar from "../components/Sidebar/Sidebar";
import ErrorSnackbar from "../components/ErrorSnackbar/ErrorSnackbar";
import SuccessSnackbar from "../components/SuccessSnackbar/SuccessSnackbar";
import "./styles.css";

const Layout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const currentStudent = useSelector(
    (state) => state.teacherReducer.currentStudent,
  );

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return (
    <div
      className={currentStudent ? "layout-container" : "dashboard-container"}>
      <ErrorSnackbar />
      <SuccessSnackbar />
      <Navbar
        setMobileOpen={setMobileOpen}
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      />
      {currentStudent && (
        <Sidebar
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
        />
      )}
      <main className="main-section-container">{children}</main>
    </div>
  );
};

export default Layout;
